//https://github.com/javascript-obfuscator/javascript-obfuscator


export class DynamicDetails  {
  constructor() {
    this.touchPosition = {
      x: 0,
      y: 0,
    };
    this.touchEventTrusted = false;
    this.mouseEventCount= 0;
    this.mousePosition= {
      x: 0,
      y: 0,
    };
    this.mouseDownCount = 0;
    this.mouseClickPosition= {
      x: 0,
      y: 0,
    };
    this.mouseEventTrusted=false;
    this.keyDownCount= 0;
    this.scrollCount= 0;
    this.windowBlur= false;
    this.windowFocus= false;
    this.consoleWindowOpened= false;
    this.ip= 0; //webrtc ipv4 address
    this.batteryLevel= 127;
    this.deviceOrientationExists= false;
    this.features = packStaticFeatureValue();
    this.checkConsoleLoopHandle = 0;
  };

  touchStartFn(e) {
    this.touchEventTrusted = e.isTrusted;
    this.mouseEventCount ++;
    let t = e.touches[0];
    this.touchPosition.x = t.clientX |0;
    this.touchPosition.y = t.clientY |0;
  };
  touchMoveFn(e) {
    this.touchEventTrusted = e.isTrusted;
    this.mouseEventCount ++;
  };
  mouseMoveFn(e) {
    this.mouseEventTrusted = e.isTrusted;
    this.mouseEventCount ++;
  };
  mouseDownFn(e) {
    //数值是不是0, 同时移动没有过界，window.outerHeight跟documentElement.clientHeight 或者document.body.clientHeight是否相等
    this.mouseEventTrusted = e.isTrusted;
    this.mouseEventCount ++;
    this.mousePosition.x = e.clientX;
    this.mousePosition.y = e.clientY;
    this.mouseDownCount ++;
  };
  mouseClickFn(e) {
    this.mouseEventTrusted = e.isTrusted;
    this.mouseEventCount ++;
    this.mouseClickPosition.x = e.clientX;
    this.mouseClickPosition.y = e.clientY;

  };
  keyDownFn(e) {
    this.keyDownCount ++;
  };
  scrollFn(e) {
    this.scrollCount ++;
  };
  focusFn(e) {
    this.windowFocus = true;
    this.windowBlur = false;
  };
  blurFn(e) {
    this.windowBlur = true;
  };
  devtoolsCb() {
    let details = this;
    const element = new Image();
    Object.defineProperty(element, 'id', {
      get: function () {
        details.consoleWindowOpened = true;
        clearInterval(details.checkConsoleLoopHandle);
      }
    });
    //console.log('%c', element);
  }
  consoleCheckLoop() {
    let func = this.devtoolsCb.bind(this);
    func();
    this.checkConsoleLoopHandle = setInterval(function(e) {
      func();
    }, 5e3);
  };
  getBatteryStatus(details) {
    if(!navigator.getBattery) {
      return;
    }
    navigator.getBattery().then(function (battery) {
      if (battery) {
        details.batteryLevel = (battery.level * 100) | 0;
      }
    });
  };
  getDeviceOrientation(details)  {
    function cb(event) {
      if (event.gamma) {
        details.deviceOrientationExists = true;
      }
      document.removeEventListener("deviceorientation", cb, false);
    }
    window.addEventListener('deviceorientation', cb, false);
  };
  getWebRTCIP(details) {
    var t = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
    if (!t)
      details.ip = 0;
    var i = {
      optional: [{
        "RtpDataChannels": !0
      }]
    };
    var r = {
      iceServers: [{
        urls: "stun:stun.services.mozilla.com"
      }],
      sdpSemantics: "plan-b"
    };
    try {
      var a = new t(r, i);
      setTimeout(function (n) {
        try {
          a.close();
        } catch (t) {}
      }, 5e3);
      a.onicecandidate = function (t) {
        var i = t.candidate;
        if (!i)
          details.ip = 0;
        r = extractIPFromWebRTCCandidate(i.candidate);
        if (null != r) {
          details.ip = r
        }
        a.onicecandidate = null;
      };
      a.createDataChannel("");
      a.createOffer().then(function (n) {
        a.setLocalDescription(n, function () {}, function () {})
      })["catch"](function (t) {
        details.ip = 0;
      });
    } catch (e) {
      details.ip = 0
    }
  };
  pack() {
    let group1 = `${this.touchPosition.x},${this.touchPosition.y},${this.touchEventTrusted ? 1: 0}`;
    let group2 = `${this.mouseEventCount},${this.mousePosition.x},${this.mousePosition.y},${this.mouseClickPosition.x},${this.mouseClickPosition.y},${this.mouseDownCount},${this.mouseEventTrusted ? 1: 0}`;
    let group3 = `${this.keyDownCount},${this.scrollCount},${this.windowBlur ? 1: 0},${this.windowFocus ? 1: 0}`;
    let group4 = `${this.consoleWindowOpened ? 1: 0},${numberToHex(this.ip)},${this.batteryLevel},${this.deviceOrientationExists?1:0}`;
    let group5 = `${numberToHex( this.features)}`;
    let all = `${group1};${group2};${group3};${group4};${group5}`;
    return all;
  };
  encode() {
    return Base64.encode( this.pack());
  };

};


export function parseMovementText(text) {
  let [group1, group2, group3, group4, group5] = text.split(";");
  let details = new DynamicDetails();
  [details.touchPosition.x, details.touchPosition.y, details.touchEventTrusted] = group1.split(",");
  details.touchEventTrusted = !!parseInt(details.touchEventTrusted);
  [details.mouseEventCount, details.mousePosition.x,details.mousePosition.y,details.mouseClickPosition.x, details.mouseClickPosition.y,details.mouseDownCount,details.mouseEventTrusted] = group2.split(",");
  details.mouseEventTrusted = !!parseInt(details.mouseEventTrusted);
  [details.keyDownCount, details.scrollCount, details.windowBlur, details.windowFocus] = group3.split(",");
  details.windowBlur = !!parseInt(details.windowBlur);
  details.windowFocus = !!parseInt(details.windowFocus);
  [details.consoleWindowOpened,details.ip,details.batteryLevel,details.deviceOrientationExists] = group4.split(",");
  details.consoleWindowOpened = !!parseInt(details.consoleWindowOpened);
  details.deviceOrientationExists = !!parseInt(details.deviceOrientationExists)
  details.ip = int2ip(parseInt(details.ip, 16));
  return [details, group5];
}


export function collectMovement(details) {
  let b = document.body;
  if ("ontouchmove" in document) {
    document.addEventListener("touchmove", details.touchMoveFn.bind(details), true);
  }
  b.addEventListener("touchstart", details.touchStartFn.bind(details), true);
  b.addEventListener("mousemove", details.mouseMoveFn.bind(details), true);
  b.addEventListener("mousedown", details.mouseDownFn.bind(details), true);
  b.addEventListener("click", details.mouseClickFn.bind(details), true);
  b.addEventListener("keydown", details.keyDownFn.bind(details), true);
  b.addEventListener("wheel", details.scrollFn.bind(details), true);
  window.addEventListener("focus", details.focusFn.bind(details), true);
  window.addEventListener("blur", details.blurFn.bind(details), true);

  details.getWebRTCIP(details);
  details.getDeviceOrientation(details);
  details.getBatteryStatus(details);
  details.consoleCheckLoop();
}




function extractIPFromWebRTCCandidate(n) {
  var t = /(\d+)\.(\d+)\.(\d+)\.(\d+)\D/.exec(n);
  return t ? (+t[1] << 24 | +t[2] << 16 | +t[3] << 8 | +t[4]) >>> 0 : null;
}

function int2ip (ipInt) {
  return ( (ipInt>>>24) +'.' + (ipInt>>16 & 255) +'.' + (ipInt>>8 & 255) +'.' + (ipInt & 255) );
}

function numberToHex(number) {
  return parseInt(number).toString(16);
}


function isNativeObject(o) {
  return !!/native code/.test(o.toString.toString()) && !!/native code/.test(o.toString());
}


function isPhantomjs() {
  let err ="";
  try {
    null[0]();
  } catch (e) {
    err = e;
  }
  return err.stack.indexOf("phantomjs") > -1;
}

function IsSupportWebGL() {
  try {
    let canvasElement = document.createElement("canvas");
    let webglContext = canvasElement.getContext("webgl");
    if (webglContext) {
      var i = webglContext.getExtension("WEBGL_lose_context");
      if (i) {
        i.loseContext();
      }
    }
    return !!webglContext;
  } catch (e) {
    return false;
  }
}

function IsSupportLocalStorage() {
  try{
    localStorage.a = "b";
    return localStorage.a === "b";
  }catch(e){
    return false;
  }
}

let headStyle = document.head.style;
let isChrome = window.chrome !== undefined;
let isIE = "ActiveXObject" in window;
let hasWeakMap = "WeakMap" in window.WeakMap && (new window.WeakMap());
let ua = navigator.userAgent;


//收集立刻能返回的标志, 通过bit set, 打包进一个interger
export let checkFunctions = {
  _1: function () {
    //chrome
    return isChrome;
  },
  _2: function () {
    //firefox
    return "mozRTCIceCandidate" in window || "mozInnerScreenY" in window;
  },
  _3: function () {
    //safari
    return "safari" in window;
  },
  _4: function () {
    //IE
    return isIE;
  },
  _5: function () {
    //IE doesn't support maxHeight
    return isIE && !("maxHeight" in headStyle);
  },
  _6: function () {
    //IE 8
    return isIE && !document.addEventListener;
  },
  _7: function () {
    //IE 9
    return isIE && !window.atob;
  },
  _8: function () {
    //IE >= 10
    return isIE && isNativeObject(window.Uint8Array);
  },
  _9: function () {
    //IE >= 11
    return isIE && hasWeakMap && isNativeObject(window.WeakMap);
  },
  _10: function () {
    //chrome
    return "Google Inc." === navigator.vendor;
  },
  _11: function () {
    //safari
    return "Apple Computer, Inc." === navigator.vendor;
  },
  _12: function () {
    //chrome headless
    return (window.innerWidth === 800 && window.innerHeight === 600 && window.outerWidth === 0 && window.outerHeight === 0) || navigator.languages == "" ||/Headless/i.test(ua);
  },
  _13: function () {
    //phantomjs
    return "callPhantom" in window || /PhantomJS/i.test(ua) || isPhantomjs();
  },
  _14: function () {
    //python
    return /python/i.test(navigator.appVersion);
  },
  _15: function () {
    return IsSupportLocalStorage();
  },
  _16: function () {
    return /Maxthon/i.test(navigator.vendor);
  },
  _17: function () {
    //opera
    return "opr" in window || "opera" in window;
  },
  _18: function () {
    //chromium based browsers
    return isChrome && /BIDUBrowser/i.test(ua);
  },
  _19: function () {
    return isChrome && /LBBROWSER/i.test(ua);
  },
  _20: function () {
    return isChrome && /QQBrowser/.test(ua);
  },
  _21: function () {
    return isChrome && /UBrowser/i.test(ua);
  },
  _22: function () {
    return isChrome && /2345Explorer/.test(ua);
  },
  _23: function () {
    return isChrome && /TheWorld/.test(ua);
  },
  _24: function () {
    //Not Chrome, it's the Edge browser
    return isChrome && "MSGesture" in window;
  },
  _25: function () {
    return isNativeObject(Object.getOwnPropertyDescriptor) && Object.getOwnPropertyDescriptor(navigator) != undefined;
  },
  _26: function () {
    //webdriver
    return "$cdc_asdjflasutopfhvcZLmcfl_" in window || navigator.webdriver;
  },
  _27: function () {
    //document is hidden
    return document.hidden;
  },
  _28: function () {
    //chinese
    return /zh-cn/i.test(navigator.language || navigator.systemLanguage);
  },
  _29: function () {
    //beijing timezone
    return -480 === (new Date()).getTimezoneOffset();
  },
  _30: function () {
    return IsSupportWebGL();
  },
  _31: function () {
    //document size compare
    //IE8 不支持outerWidth, 同时如果成立表示， 没有显示滚动条
    return window.outerWidth !== null && (window.outerWidth === document.documentElement.clientWidth || document.body.clientWidth);
  },

};

export function packStaticFeatureValue() {
  let value = 0;
  for (let i in checkFunctions) {
    let shift = parseInt(i.split("_")[1]) - 1;
    let set = 0;
    try {
      set = checkFunctions[i]() ? 1 : 0;
    } catch (e) {
    }
    value |= set << shift;
  }
  return value;
}


export function unpackStaticFeatureValue(value) {
  let number = parseInt(value, 16);
  let statuses = []
  for(let i = 0; i <31; i++) {
    let status = (number & (1 << i)) > 0;
    statuses.push(status);
  }
  return statuses;
}


//用js实现， 打乱码表
export var Base64 = {
  // private property
  _keyStr: "ZLHUPIO4tAok06E/caWCmSFfKusy3nrjJRzDTvBgY7wdMlXp82NViGq=+Qheb91x5",

  // public method for encoding
  encode: function (input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    input = Base64._utf8_encode(input);

    while (i < input.length) {

      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output +
        this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

    }

    return output;
  },

  // public method for decoding
  decode: function (input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    while (i < input.length) {

      enc1 = this._keyStr.indexOf(input.charAt(i++));
      enc2 = this._keyStr.indexOf(input.charAt(i++));
      enc3 = this._keyStr.indexOf(input.charAt(i++));
      enc4 = this._keyStr.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }

    }

    output = Base64._utf8_decode(output);

    return output;

  },

  // private method for UTF-8 encoding
  _utf8_encode: function (string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";

    for (var n = 0; n < string.length; n++) {

      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }

    }

    return utftext;
  },

  // private method for UTF-8 decoding
  _utf8_decode: function (utftext) {
    let string = "";
    let i = 0;
    let c = 0;
    let c2 = 0;
    let c3 = 0;

    while (i < utftext.length) {

      c = utftext.charCodeAt(i);

      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if ((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }

    }

    return string;
  }

};


